import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useCollectorIntermediateStyles = makeStyles<Theme>((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '95vh'
  },
  containerRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center'
  },
  containerCol: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8)
  },
  collectorImage: {
    width: theme.spacing(16),
    height: theme.spacing(16),
    marginLeft: theme.spacing(7),
    display: 'flex'
  },
  arrowIconBack: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginLeft: theme.spacing(3)
  },
  arrowIconForward: {
    width: theme.spacing(4),
    height: theme.spacing(4),
    marginLeft: theme.spacing(8)
  },
  tiLogo: {
    width: theme.spacing(16),
    height: theme.spacing(16)
  }
}));

export default useCollectorIntermediateStyles;
